import React, { Component } from 'react';
import { connect } from 'react-redux';
import Row from '../../../../common/grid/Row.js';
import Col from '../../../../common/grid/Col.js';
import Button from '../../../../common/button/Button.js';
import Input from '../../../../common/input/Input.js';
import UploadButton from '../../../../common/button/UploadButton.js';
import Select from "../../../../common/select/Select.js";
import { validate } from "../../../../helpers/validate.js";

// Actions
import { setErrors, clearErrors } from '../../../../actions/error.js';
import { createLetter } from "../../../../actions/letter.js";

import './AddLetter.css';

class AddLetter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      file: '',
      name: '',
      navigationBlocked: false
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.onSubmitClick = this.onSubmitClick.bind(this);
    this.validate = this.validate.bind(this);
    this.onFileUpload = this.onFileUpload.bind(this);
  }

  handleInputChange(text, name) {
    this.setState({ [name]: text });
  }

  onFileUpload(e) {
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];

    reader.onloadend = () => {
      this.setState({
        filename: file.name,
        file: file,
        data: reader.result,
      });
    };

    reader.readAsDataURL(file);
  }

  validate() {
    const checkAgainst = [
      'file',
      'sender',
      'recipient',
      'type',
      'date_of_action'
    ];

    const errors = validate(this.state, checkAgainst);
    this.props.addErrors(errors);

    return Object.keys(errors).length === 0;
  }

  onSubmitClick(e) {
    e.preventDefault();

    if (this.validate()) {
      // navigation is not blocked anymore
      this.setState({ navigationBlocked: false });

      const letter = {
        file: this.state.file,
        sender: this.state.sender,
        recipient: this.state.recipient,
        type: this.state.type,
        date_of_action: this.state.date_of_action
      };

      this.props.emptyErrors();
      this.props.createLetter(letter);
      alert('Letter has been added!');
    }
  }

  componentWillUnmount() {
    this.setState({
      file: null,
      sender: null,
      recipient: null,
      type: null,
      date_of_action: null,
    });

    if (this.state.navigationBlocked) {
      alert("You've navigated away. All changes destroyed!");
    }
  }

  render() {
    return (
      <div className='add-letter'>
        <h2>Add Letter</h2>
        <Col _bottom-8>
          <Row>
            <Input
              ph='Sender'
              name='sender'
              value={this.state.sender}
              onChange={this.handleInputChange}
            />
          </Row>
          <Row>
            <Input
              ph='Recipient'
              name='recipient'
              value={this.state.recipient}
              onChange={this.handleInputChange}
            />
          </Row>
          <Row>
            <Select
              name='type'
              options={[
                {
                  value: 'received',
                  name: 'Received'
                },
                {
                  value: 'sent',
                  name: 'Sent'
                }
              ]}
              value={this.state.type}
              onChange={this.handleInputChange}
            />
          </Row>
          <Row>
          </Row>
          <Row>
            <span className='date-title'>{this.state.type === 'sent' ? 'Sent at' : 'Received at'}</span>
            <Input
              name='date_of_action'
              type='date'
              value={this.state.date_of_action}
              onChange={this.handleInputChange}
              ph={this.state.type === 'sent' ? 'Sent at' : 'Received at'} />
          </Row>
          <Row file_updload>
            <span className='filename'>{this.state.filename ? this.state.filename : 'Please, add a file'}</span>
            <UploadButton
              className="btn-blue btn-square add-file-btn"
              onChange={this.onFileUpload}
              accept='*'
              name='file'>
              {this.state.file ? 'Change File' : 'Add File'}
            </UploadButton>
          </Row>
          <Row _space-between>
            <Button className="btn-green btn-square" onClick={this.onSubmitClick}>Save</Button>
          </Row>
        </Col>
      </div >
    );
  }
}

const mapDispatchToProps = {
  addErrors: (errors) => dispatch => dispatch(setErrors(errors)),
  emptyErrors: () => dispatch => dispatch(clearErrors()),
  createLetter
}

export default connect(null, mapDispatchToProps)(AddLetter);


// WEBPACK FOOTER //
// ./src/components/main/letters/add/AddLetter.js